import { Button } from '@pms-digital/design-system';
import { type ReactNode, useId } from 'react';

interface ExportOptionCategoryProps {
  title: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}

/** One collapsible block of the export panel, with a chevron header. */
export function ExportOptionCategory({
  title,
  open,
  onToggle,
  children,
}: ExportOptionCategoryProps) {
  const bodyId = useId();
  return (
    <section className="border-gray-100 border-t first:border-t-0">
      <h3 className="py-1">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          fullWidth
          aria-expanded={open}
          aria-controls={open ? bodyId : undefined}
          iconAfter={open ? 'expand_more' : 'chevron_right'}
          onClick={onToggle}
        >
          {title}
        </Button>
      </h3>
      {open && (
        <div id={bodyId} className="space-y-3 pb-3">
          {children}
        </div>
      )}
    </section>
  );
}
